/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2024, Zumper
 * @description  Constants for BuildingReviewsData module
 */

export const CLEAR_BUILDING_REVIEWS_DATA = '@@nzr/Detail/CLEAR_BUILDING_REVIEWS_DATA' as const
export const DONE_FETCHING_BUILDING_REVIEWS_DATA =
  '@@nzr/Detail/DONE_FETCHING_BUILDING_REVIEWS_DATA' as const
export const ERROR_FETCHING_BUILDING_REVIEWS_DATA =
  '@@nzr/Detail/ERROR_FETCHING_BUILDING_REVIEWS_DATA' as const
export const RECEIVE_BUILDING_REVIEWS_DATA = '@@nzr/Detail/RECEIVE_BUILDING_REVIEWS_DATA' as const
export const START_FETCHING_BUILDING_REVIEWS_DATA =
  '@@nzr/Detail/START_FETCHING_BUILDING_REVIEWS_DATA' as const
